import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui'
import Modal from '@mui/material/Modal';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import './GenerarReporteButton.css'
import FormularioReporte from '../FormularioReporte/FormularioReporte';
import LoaderPDF from '../LoaderPDF/LoaderPDF';
import AssessmentIcon from '@mui/icons-material/Assessment';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import SuccessDialog from '../SuccessDialogPDF/SuccessDialog';

const useStyles = makeStyles({ name: 'App' })((theme) => ({
    root: {
        position: 'absolute',
        width: '50%',
        height: '90vh',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #be0411',
        boxShadow: theme.shadows[5],
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        flexDirection: "column",
        borderRadius: 6,
        padding: '1em 0',
        flex: "1"
    }
}),
);

const AlertComponent = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


interface Props {
    idProject: string;
    nombreCliente: string;
    fechaInicioProyecto: Date;
    fechaMax: Date;
    semanaSelected?: string
}

const GenerarReporteButton: FC<Props> = ({ idProject, nombreCliente, fechaInicioProyecto, fechaMax, semanaSelected }) => {
    const [datosVacios, setDatosVacios] = useState('')
    const [clickupLink, setClickupLink] = useState<string | null>(null)
    const [showSuccessDialog, setShowSuccessDialog] = useState(false)
    const loadingPdfState = useSelector((state: any) => state.certificados?.loadingPdf || false)

    const { classes } = useStyles();

    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        // Resetear el estado cuando se cierra el modal
        setDatosVacios('')
    };

    const handleOpenClickupLink = () => {
        if (clickupLink) {
            window.open(clickupLink, '_blank')
        }
        setShowSuccessDialog(false)
    };

    const body = (
        <div className={classes.root}>
            <div className='container-header-reporte'>
                <h2 id="simple-modal-title" className="reporteTitulo">Reporte Certificación</h2>
                <CloseIcon sx={{color: '#be0411', fontSize: 40}} className='icon-close' onClick={handleClose}/>
            </div>
            <FormularioReporte 
                close={handleClose} 
                idProject={idProject} 
                nombreCliente={nombreCliente} 
                fechaInicioProyecto={fechaInicioProyecto} 
                datosVacios={datosVacios} 
                setDatosVacios={setDatosVacios}
                setClickupLink={setClickupLink}
                setShowSuccessDialog={setShowSuccessDialog}
                fechaMax={fechaMax} 
                semanaSelected={semanaSelected}
            />
        </div>
    );

    return (
        <div>
            <SuccessDialog
                open={showSuccessDialog}
                onClose={() => setShowSuccessDialog(false)}
                clickupLink={clickupLink}
            />
            {/* Loader - Se muestra cuando está cargando */}
            {loadingPdfState && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <LoaderPDF />
                </div>
            )}

            <button type="button" onClick={handleOpen} className="reporteButton">
                Reporte PDF
                <AssessmentIcon className='iconReporte' />
            </button>
            <Modal
                open={open && !loadingPdfState}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className='reporteContainer'
            >
                <>
                    {body}
                    {/* Mostramos otros mensajes de error si es necesario (solo dentro del modal) */}
                    {datosVacios !== '' && datosVacios !== 'completo' && (
                        <div className='box-alert'>
                            <Alert variant='filled' severity='error' className='alert'>
                                {
                                    datosVacios === 'vacio'
                                        ? '¡Datos del reporte Incompletos!'
                                        : datosVacios === 'error'
                                        ? '¡Error al intentar generar el reporte!'
                                        : datosVacios === 'checkboxs'
                                        ? '¡Debe Incluir Horas y/o Monto Devengado en el reporte!'
                                        : ''
                                }
                            </Alert>
                        </div>
                    )}
                </>
            </Modal>
        </div>
    );
}

export default GenerarReporteButton